import i18n from 'i18next'

export const REACT_TABLE_TRANSLATIONS = {
    previousText: i18n.t("common:grid.previous"),
    loadingText: i18n.t("common:grid.loading"),
    nextText: i18n.t("common:grid.next"),
    noDataText: i18n.t("common:grid.noRowsFound"),
    pageText: i18n.t("common:grid.page"),
    ofText: i18n.t("common:grid.of"),
    rowsText: i18n.t("common:grid.rows"),
};